// extracted by mini-css-extract-plugin
export default {"root":"ScanDetails_root__UsSoK","counter":"ScanDetails_counter__oIuSp","label":"ScanDetails_label__Ibnm4","link":"ScanDetails_link__1VHG6"};